import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TClipPeople } from '../types';

type TDeleteClipPeopleParams = {
  id: string;
  silently?: boolean;
};
export async function deleteClipPeople({ id }: TDeleteClipPeopleParams): Promise<TClipPeople> {
  return mediaManagerClient.delete(`/api/v1/clip_people/${id}`);
}

type MutationFn = typeof deleteClipPeople;

type TUsePostFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteClipPeople({ config = {} }: TUsePostFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...params }: TDeleteClipPeopleParams) =>
      deleteClipPeople({ ...params, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la persona de interés del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TDeleteClipPeopleParams) {
      if (!variables.silently) {
        addSuccessNotification(t('La persona de interés se ha eliminado correctamente'));
      }
    },
  });
}
